import * as React from 'react';
import { useCookieConsentContext, isCookieCategoryEnabled } from '@grandvisionhq/cookie-consent';

function ImBox({ imBoxId , ScriptComponent  }) {
    const strategy = React.useRef('beforeInteractive');
    const consentResult = useCookieConsentContext();
    if (!isCookieCategoryEnabled('functional', consentResult)) {
        // the beforeInteractive strategy won't inject the script after effects
        strategy.current = 'afterInteractive';
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ScriptComponent, {
        strategy: strategy.current
    }, `var _sid = '${imBoxId}';`), /*#__PURE__*/ React.createElement(ScriptComponent, {
        strategy: strategy.current,
        type: "text/javascript",
        src: `https://files.imbox.io/app/dist/initWidget.js`
    }));
}

export { ImBox };
//# sourceMappingURL=ImBox.js.map
